<template>
  <div class="admin-pis__toolbar">
    <div class="button-group">
      <button
        class="button"
        @click.prevent="sendAction('call')"
      >
        <span class="button__icon">
          <i class="icon icon-speaker" />
        </span>
        <span class="button__label">Call</span>
        <span class="button__label">(1)</span>
      </button>
      <button class="button"
              @click.prevent="transferModal"
      >
        <span class="button__icon">
          <i class="icon icon-low-priority" />
        </span>
        <span class="button__label">Transfer</span>
        <span class="button__label">(2)</span>
      </button>
      <button
        class="button"
        @click.prevent="sendAction('next')"
      >
        <span class="button__icon">
          <i class="icon icon-direction-right" />
        </span>
        <span class="button__label">Skip/Next</span>
        <span class="button__label">(3)</span>
      </button>
      <InertiaLink
        class="button"
        :href="route('counters.index')"
      >
        <span class="button__icon">
          <i class="icon icon-e-remove" />
        </span>
        <span class="button__label">Close</span>
      </InertiaLink>
    </div>
  </div>
</template>

<script>
import TransferModal from '@components/settings/TransferModal'
import debounce from 'lodash/debounce'
import Mousetrap from 'mousetrap'

export default {
  props: {
    counter: {
      type: Object,
      required: true,
    },
    counters: {
      type: Array,
      required: true,
    },
  },
  mounted () {
    Mousetrap.bind('1', () => {
      this.sendAction('call')
    })
    Mousetrap.bind('2', () => {
      this.transferModal()
    })
    Mousetrap.bind('3', () => {
      this.sendAction('next')
    })
  },
  methods: {
    transferModal () {
      this.$store.dispatch('modal/open', {
        modal: TransferModal,
        counter: this.counter,
        counters: this.counters,
      })
    },
    sendAction: debounce(function(action) {
      this.$inertia.post(this.route('actions'), {
        action,
        counter_id: this.counter.id,
        type: this.counter.default_type,
      })
    }, 500),
  },
}
</script>
